import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MetaIdInterceptor } from './meta-id.interceptor';
import { AuthInterceptor } from './auth.interceptor';

/** Array of Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: MetaIdInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
